import React, { useContext, useEffect, useState } from 'react';

import BulkTimeEntryContext from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryContext';

const BulkTimeTotalHoursPending = () => {
  const { taskTimeItems } = useContext(BulkTimeEntryContext);
  const [totalHours, setTotalHours] = useState<number>(0);

  useEffect(() => {
    const itemsWithHours = taskTimeItems.filter(
      (chk) => chk.timeEntry.hoursLogged > 0,
    );
    let newHours = 0;
    itemsWithHours.forEach((item) => (newHours += item.timeEntry.hoursLogged));

    setTotalHours(newHours);
  }, [taskTimeItems]);

  return (
    <span style={{ color: '#ff0000', marginRight: '16px' }}>
      New Hours: {totalHours}
    </span>
  );
};

export default BulkTimeTotalHoursPending;
